import React from 'react';

const Confirmation = () => {
    return (
        <>
            <h2 className="display5 text-center bold mb-3">Check your email</h2>

            <p className="text-center mb-3 red-hat" style={{ fontSize: '1rem', lineHeight: 1.4, width: '95%' }}>
                If there’s an ICSC account associated with the provided email address or member ID, you’ll get an email
                with a link to reset your password. The link will expire in 2 hours.
            </p>

            <p className="text-center mb-3 red-hat" style={{ fontSize: '1rem', lineHeight: 1.4, width: '95%', fontWeight: 700 }}>
                If you do not see the email, please check your spam folder and whitelist login@icsc.com.
            </p>

            <p className="text-center mb-3 red-hat" style={{ fontSize: '1rem', lineHeight: 1.4, width: '95%' }}>
                Still need help?
            </p>

            <p className="text-center mb-4 red-hat" style={{ fontSize: '1rem', lineHeight: 1.4, width: '95%' }}>
                <a className="accent" href="mailto:membership@icsc.com">
                    Contact us.
                </a>
            </p>
        </>
    );
};

export default Confirmation;
